import { useMutation } from "@tanstack/react-query";
import { acceptUserTerms } from "api/accept-user-terms";

export const useAcceptUserTerms = () => {
  const acceptTerms = useMutation({
    mutationFn: (version: string) => acceptUserTerms(version),
  });

  return async (version: string) => {
    try {
      const response = await acceptTerms.mutateAsync(version);
      return { success: Boolean(response.date_accepted) };
    } catch (error) {
      throw new Error();
    }
  };
};
